import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import React from 'react';
import AsLinearShrinkageCuringSection from './CuringSection';
import AsLinearShrinkageDryingSection from './DryingSection';
import AsLinearShrinkageEquipmentSection from './EquipmentSection';
import AsLinearShrinkageSampleMassSection from './SampleMassSection';
import AsLinearShrinkageTestForMCSection from './TestForMoistureConditionSection';

let AsLinearShrinkagePreparationSection: React.FC = () => {
  return (
    <>
      <AsLinearShrinkageSampleMassSection />
      <AsLinearShrinkageCuringSection />
      <AsLinearShrinkageTestForMCSection />
      <AsLinearShrinkageEquipmentSection />
      <AsLinearShrinkageDryingSection />
    </>
  );
};

AsLinearShrinkagePreparationSection = withInjectedProps(AsLinearShrinkagePreparationSection);

export { AsLinearShrinkagePreparationSection };
export default AsLinearShrinkagePreparationSection;
